
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFFFFF",
        "d": "M18.209,13.738c0.003,0.063,0.007,0.127,0.01,0.193\n\tc-0.536,0.127-0.958,0.816-0.866,1.766c0.094,0.962,1.064,2.059,1.705,2.248c0.905,2.318,2.095,4.537,4.879,4.537\n\tc2.785,0,3.976-2.219,4.882-4.537c0.639-0.189,1.611-1.286,1.704-2.248c0.093-0.949-0.331-1.639-0.867-1.766\n\tc0.005-0.066,0.008-0.131,0.011-0.193C30.1,4.904,17.774,4.904,18.209,13.738L18.209,13.738z M22.831,26.934l-0.511-1.713h3.234\n\tl-0.511,1.713l1.095,4.91l3.235-7.686c0.075-0.177,0.288-0.238,0.468-0.172l5.053,1.879c1.49,0.557,2.535,1.5,2.62,2.273\n\tl0.661,6.047c0.039,0.357-0.064,0.681-0.304,0.947c-0.239,0.268-0.55,0.404-0.909,0.404H10.91c-0.358,0-0.668-0.137-0.907-0.404\n\tc-0.239-0.267-0.343-0.59-0.304-0.947l0.66-6.047c0.085-0.771,1.131-1.719,2.621-2.273l5.053-1.879\n\tc0.176-0.074,0.392-0.005,0.467,0.172l3.236,7.686L22.831,26.934L22.831,26.934z"
      }
    }
  ]
})
    }
  